import { useEffect, useState } from "react";
import { fetchTrackBoard } from "@/lib/api";

const Column = ({ title, rows, ready }) => (
    <section className={`flex-1 border-2 p-6 md:p-10 ${ready ? "border-[var(--gold)] bg-[var(--gold)]/5" : "border-[var(--border)]"}`} data-testid={`track-${ready ? "ready" : "preparing"}`}>
        <h2 className={`font-display text-[40px] md:text-[56px] leading-none mb-8 ${ready ? "text-gold" : ""}`}>{title}</h2>
        {rows.length === 0 ? (
            <p className="font-mono text-[14px] uppercase tracking-[0.2em] text-muted">—</p>
        ) : (
            <div className="grid gap-4" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))" }}>
                {rows.map((r) => (
                    <div key={r.number} className={`p-4 text-center ${ready ? "bg-[var(--gold)] text-[var(--bg)] animate-pulse" : "bg-[var(--surface)]"}`} data-testid={`track-order-${r.number}`}>
                        <div className="font-display text-[44px] md:text-[56px] leading-none">{r.number}</div>
                        {r.name && <div className="font-mono text-[12px] uppercase tracking-[0.18em] mt-2 opacity-80 truncate">{r.name}</div>}
                    </div>
                ))}
            </div>
        )}
    </section>
);

export default function TrackBoard() {
    const [board, setBoard] = useState({ preparing: [], ready: [] });
    useEffect(() => {
        const load = () => fetchTrackBoard().then(setBoard).catch(() => {});
        load();
        const t = setInterval(load, 8000);
        return () => clearInterval(t);
    }, []);
    return (
        <div className="min-h-screen bg-[var(--bg)] text-[var(--text)] p-6 md:p-10 flex flex-col" data-testid="track-board">
            <header className="flex items-baseline justify-between mb-8">
                <div className="font-display text-[32px]">naami<span className="text-gold">.</span></div>
                <span className="font-mono text-[12px] uppercase tracking-[0.22em] text-gold">// Order status</span>
            </header>
            <div className="flex-1 flex flex-col lg:flex-row gap-6">
                <Column title="Preparing" rows={board.preparing} />
                <Column title="Ready to collect" rows={board.ready} ready />
            </div>
        </div>
    );
}
